export interface Testimonials {
    id: number;
    review: string;
    profile_image: string;
    profile_name: string;
    role: string;
    working_place: string;
}

export const testimonials: Testimonials[] = [
    {
        "id": 1,
        "review": "Traqdo has been a game-changer for our team. Their insights helped us identify key improvement areas, enabling us to enhance our efficiency and performance. We couldn't have asked for a better tool to support our growth!",
        "profile_image": "https://mdbcdn.b-cdn.net/img/new/avatars/1.webp",
        "profile_name": "Daniel Carter",
        "role": "Project Manager",
        "working_place": "Summit Builders"
    },
    {
        "id": 2,
        "review": "The Traqdo team truly transformed our workflow. Their expertise in streamlining project management processes was invaluable, and we've seen a significant boost in team productivity since using the platform.",
        "profile_image": "https://mdbcdn.b-cdn.net/img/new/avatars/2.webp",
        "profile_name": "Jane Smith",
        "role": "Marketing Director",
        "working_place": "BlueSky Construction"
    },
    {
        "id": 3,
        "review": "Working with Traqdo was an eye-opening experience. Their approach to team and project management was both strategic and data-driven, leading to immediate improvements in our project timelines and team collaboration.",
        "profile_image": "https://mdbcdn.b-cdn.net/img/new/avatars/3.webp",
        "profile_name": "Alex Johnson",
        "role": "Lead Developer",
        "working_place": "Tech Innovations Inc."
    },
    {
        "id": 4,
        "review": "Traqdo has revolutionized how we approach project management. Their tools helped us identify critical areas for growth and provided actionable strategies that led to remarkable improvements across our team’s performance.",
        "profile_image": "https://mdbcdn.b-cdn.net/img/new/avatars/4.webp",
        "profile_name": "Emily Davis",
        "role": "Operations Manager",
        "working_place": "Global Enterprises Ltd."
    },
    {
        "id": 5,
        "review": "The insights we gained from Traqdo were exactly what we needed to improve our team's efficiency. Their platform helped us see our strengths and weaknesses clearly, allowing us to implement effective strategies for growth.",
        "profile_image": "https://mdbcdn.b-cdn.net/img/new/avatars/5.webp",
        "profile_name": "Olivia Bennett",
        "role": "CEO",
        "working_place": "NextGen Solutions Inc."
    }
];
